import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Form, Formik } from 'formik';

import Button from '@components/smartAdminUI/Button';
import FormikField from '@components/form/FormikField';

const OfficeSearchForm = ({ onSubmitClicked }) => {
  const formSubmitting = useSelector(state => state.office.isLoading);

  const handleSubmit = values => {
    onSubmitClicked(values);
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        UniqueID: '',
        OfficeName: '',
        OfficeCity: '',
      }}
    >
      {({ handleReset }) => (
        <Form>
          <FormikField
            datatype="string"
            fieldLabel="Office ID"
            FieldName="OfficeMlsID"
            inputType="TextInput"
            IsVisible
          />
          <FormikField
            datatype="string"
            fieldLabel="Office Name"
            FieldName="OfficeName"
            inputType="TextInput"
            IsVisible
          />
          <FormikField
            datatype="string"
            fieldLabel="City"
            FieldName="OfficeCity"
            inputType="TextInput"
            IsVisible
          />
          <Button
            name="btnSearchOffice"
            variant="primary"
            type="submit"
          >
            {formSubmitting
              ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
                  Searching...
                </>
              ) : (
                <>
                  <i className="fas fa-search mr-2" aria-hidden="true" />
                  Search
                </>
              )}
          </Button>
          <Button
            name="btnSearchOfficeClear"
            onClick={handleReset}
            variant="primary"
          >
            <i className="fas fa-times mr-2" />
            Clear
          </Button>
        </Form>
      )}
    </Formik>
  );
};

OfficeSearchForm.propTypes = {
  onSubmitClicked: PropTypes.func,
};

export default OfficeSearchForm;
